import { makeStyles } from '@material-ui/core'
import React from 'react'
import Carousel from 'react-material-ui-carousel'

const useStyles = makeStyles(theme => ({
  root: {
    margin: 5,
    borderRadius: 24,
    background: '#FFFFFF',
    boxShadow: ({ isSelected }) => (isSelected ? '0 0 4px 0px #3c52ef' : 'none'),
    transition: 'box-shadow 0.3s ease',
    paddingBottom: ({ addPadding }) => (addPadding ? 26 : undefined)
  },
  indicatorsContainer: {
    paddingBottom: 10,
    marginTop: '0px !important',
    position: 'relative',
    zIndex: 1
  },
  indicator: {
    transform: 'scale(0.8)',
    color: '#D9D9D9 !important'
  },
  activeIndicator: {
    transform: 'scale(0.8)',
    color: '#3c52ef !important'
  }
}))

const BaseWidget = ({ children, className, carousel = true, isLoading = false, isSelected, removePadding = false }) => {
  const childrenArray = React.Children.toArray(children)

  const classes = useStyles({
    hideIndicators: childrenArray.length < 2,
    addPadding: !removePadding && !carousel,
    isSelected
  })

  return carousel ? (
    <Carousel
      id="widget-carousel"
      autoPlay={!isLoading}
      indicators={true}
      interval={8000}
      stopAutoPlayOnHover
      navButtonsAlwaysInvisible={true}
      navButtonsAlwaysVisible={false}
      animation="slide"
      className={[classes.root, className || ''].join(' ')}
      activeIndicatorIconButtonProps={{
        className: classes.activeIndicator
      }}
      indicatorIconButtonProps={{
        className: classes.indicator
      }}
      indicatorContainerProps={{
        className: classes.indicatorsContainer
      }}
    >
      {childrenArray}
    </Carousel>
  ) : (
    <div className={[classes.root, className || ''].join(' ')}>{children}</div>
  )
}

export default BaseWidget
